var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header',{attrs:{"title":"My Admin","description":"Manage administrative control over your platform. Manage user permission, access settings, and oversee various administrative features to keep your platform running smoothly."}}),_c('div',{staticClass:"flex bg-white fixed-top"},[_c('div',{staticClass:"p-6 w-full pb-8 menucontrol-scroll"},[(
          ['Admin', 'Developer'].includes(_vm.login.role) ||
          _vm.multiLineArray(_vm.userModules, _vm.customPages)
        )?_c('Custom-pages',{attrs:{"customPages":_vm.filteredCustomPages}}):_vm._e(),(
          ['Admin', 'Developer'].includes(_vm.login.role) ||
          _vm.modules.filter((x) => x === 'User Management').length
        )?_c('UserManagement'):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Project Management' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role) &&
                _vm.login.reseller == _vm.selectedProject.reseller) ||
              (x === 'Project Management' &&
                _vm.login.reseller == _vm.selectedProject.reseller)
          ).length
        )?_c('project-management'):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Blog' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Blog'
          ).length
        )?_c('AdminBlogs'):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Portfolio' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Portfolio'
          ).length
        )?_c('Portfolio'):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Ecommerce' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Ecommerce'
          ).length
        )?_c('div',[_c('Ecommerce')],1):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Marketplace' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Marketplace'
          ).length
        )?_c('div',[_c('Marketplace')],1):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'OTT' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'OTT'
          ).length
        )?_c('div',[_c('OTT')],1):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Booking Engine' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Booking Engine'
          ).length
        )?_c('div',[_c('BookingEngine')],1):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Metaverse' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Metaverse'
          ).length
        )?_c('div',[_c('Metaverse')],1):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'Whatsapp Bot' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'Whatsapp Bot'
          ).length
        )?_c('div',[_c('WhatsAppBot')],1):_vm._e(),(
          _vm.modules.filter(
            (x) =>
              (x.extensionId &&
                x.extensionId.name === 'E-learning' &&
                x.status === 'Active' &&
                ['Admin', 'Developer'].includes(_vm.login.role)) ||
              x === 'E-learning'
          ).length
        )?_c('div',[_c('Elearning')],1):_vm._e(),_c('div',[(
            _vm.modules.filter(
              (x) =>
                (x.extensionId &&
                  x.extensionId.name === 'Social' &&
                  x.status === 'Active' &&
                  ['Admin', 'Developer'].includes(_vm.login.role)) ||
                x === 'Social'
            ).length
          )?_c('AdminSocial'):_vm._e()],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }